import Vue from 'vue'
import { CryptoStorage } from '@webcrypto/storage'

Vue.prototype.$secure = new CryptoStorage('my crypto key')
